import React, { Component, Fragment, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import Progress from "react-svg-progress";
import I18n from "i18n-js";

import api from "../api";

import Page from "./components/Page";
import TimeForm from "./components/TimeForm";
import TimeZoneForm from "./components/TimeZoneForm";

const DateTime = ({ availableHourStyles, hourStyle, timeZone, user }) => {

  const [loading, setLoading] = useState(false);
  const [selectedHourStyle, setSelectedHourStyle] = useState(hourStyle);
  const [selectedTimeZone, setSelectedTimeZone] = useState(timeZone);

  const updateSettings = () => {
    setLoading(true);
    
    const data = {
      hour_style: selectedHourStyle,
      time_zone: selectedTimeZone
    };

    api.post("/users/settings", data)
      .then(res => {
        console.log(res);
        setTimeout(() => {
          toast.success(<b>{I18n.t("common.saved_successfully")}</b>);
          setLoading(false);
        }, 500);
      })
      .catch(err => {
        if (err.response && err.response.data && err.response.data.message) {
          toast.error(<b>{err.response.data.message}</b>);
        } else {
          toast.error(<b>{I18n.t("common.errors.unexpected_error")}</b>);
        }
        setLoading(false);
        console.error(err);
      });
  }

  const handleSave = () => {
    updateSettings();
  }

  const handleCancel = () => {
    setSelectedHourStyle(hourStyle);
    setSelectedTimeZone(timeZone);
  }

  return (
    <Fragment>
      <Page
        className="date-page"
        title={I18n.t("settings.pages.date_time.title")}
        subtitle={I18n.t("settings.pages.date_time.subtitle")}
        user={user}
      >
        <TimeForm
          availableHourStyles={availableHourStyles}
          hourStyle={selectedHourStyle}
          onHourStyleSelected={setSelectedHourStyle}
        />
        <TimeZoneForm
          timeZone={selectedTimeZone}
          onTimeZoneSelected={setSelectedTimeZone}
        />
        <div className="separator" />
        <div className="buttons-section">
          <button
            className="cancel-btn"
            disabled={loading}
            onClick={handleCancel}
          >
            {I18n.t("settings.actions.cancel")}
          </button>
          <button
            className="save-btn"
            disabled={loading}
            onClick={handleSave}
          >
            <span className={loading ? "loading" : ""}>
              {I18n.t("settings.actions.save")}
            </span>
            <div className={loading ? "progress loading" : "progress"}>
              <Progress color="#FFFFFF" size="16px" />
            </div>
          </button>
        </div>
      </Page>
      <Toaster
        position="top-right"
        reverseOrder
      />
    </Fragment>
  );
}

// NOTE: needed now to current version of ReactOnRails to work with hooks
export default class DateTimeComponent extends Component {
  render() {
    return <DateTime {...this.props} />;
  }
}
